// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kbaAuthRetry_kbaTitle__EtRv7 {
    color: #5151f9;
    font-family: 'Poppins', sans-serif;
    font-size: 34px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-top: 40px;
    margin-bottom: 24px;
}

.kbaAuthRetry_kbaKnowledgeBasedText__YwEuw {
    margin-top: 34px;
    color: #475569;
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    font-weight: 400;
}

.kbaAuthRetry_kbaQuestionBasedText__snRx6 {
    color: #fff;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    display: flex;
    padding: 16px 24px;
    align-items: center;
    gap: 10px;
    border-radius: 4px;
    background: #000;
    margin-top: 30px;
}

.kbaAuthRetry_kbaRadioInputsContainer__FzdWE {
    display: flex;
    flex-direction: column;
    margin-top: 24px;
    gap: 15px;
}
.kbaAuthRetry_kbaRadioInputs__nWcf6 {
    display: flex;
    gap: 10px;
    color: #475569;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    align-items: start;
}
.kbaAuthRetry_kbaRadioInputs__nWcf6 input,
.kbaAuthRetry_kbaRadioInputs__nWcf6 label {
    cursor: pointer;
}
.kbaAuthRetry_kbaSubmit__wwS5W {
    color: #fff;
    font-family: 'Poppins', sans-serif;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-top: 30px;
    border: none;
    border-radius: 4px;
    background: rgba(81, 81, 249, 0.5);
    display: flex;
    width: 384px;
    padding: 16px 24px;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.kbaAuthRetry_kbaContent__oO-K7 {
    padding: 80px 80px 0px 80px;
}

.kbaAuthRetry_kbaError__uZRYD {
    border-radius: 4px;
    border: 1px solid #ff4040;
    background: #fff;
    display: flex;
    padding: 16px 12px;
    align-items: center;
    gap: 10px;
    width: max-content;
}

.kbaAuthRetry_cardBodyCustom__VfLln {
    width: 100% !important;
}

.kbaAuthRetry_authSuccess__JR\\+F5 {
    margin-top: 20px;
    border-radius: 4px;
    border: 1px solid #5151f9;
    background: #fff;
    color: #5151f9;
    font-family: 'Poppins', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    padding: 20px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 30px;
}

/* Responsive Styling */
@media (max-width: 768px) {
    .kbaAuthRetry_kbaContent__oO-K7 {
        padding: 80px 40px 80px 40px;
    }

    .kbaAuthRetry_kbaSubmit__wwS5W {
        width: 100%;
    }
}

@media (max-width: 992px) {
    .kbaAuthRetry_kbaContainer__-OJrQ {
        min-height: 100vh;
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/kbaAuthRetry/kbaAuthRetry.module.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,aAAa;IACb,SAAS;IACT,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;AACA;;IAEI,eAAe;AACnB;AACA;IACI,WAAW;IACX,kCAAkC;IAClC,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,kCAAkC;IAClC,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;AACb;;AAEA,uBAAuB;AACvB;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,0BAA0B;IAC9B;AACJ","sourcesContent":[".kbaTitle {\n    color: #5151f9;\n    font-family: 'Poppins', sans-serif;\n    font-size: 34px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    margin-top: 40px;\n    margin-bottom: 24px;\n}\n\n.kbaKnowledgeBasedText {\n    margin-top: 34px;\n    color: #475569;\n    font-family: 'Poppins', sans-serif;\n    font-style: normal;\n    font-weight: 400;\n}\n\n.kbaQuestionBasedText {\n    color: #fff;\n    font-family: 'Poppins', sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    display: flex;\n    padding: 16px 24px;\n    align-items: center;\n    gap: 10px;\n    border-radius: 4px;\n    background: #000;\n    margin-top: 30px;\n}\n\n.kbaRadioInputsContainer {\n    display: flex;\n    flex-direction: column;\n    margin-top: 24px;\n    gap: 15px;\n}\n.kbaRadioInputs {\n    display: flex;\n    gap: 10px;\n    color: #475569;\n    font-family: 'Poppins', sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    align-items: start;\n}\n.kbaRadioInputs input,\n.kbaRadioInputs label {\n    cursor: pointer;\n}\n.kbaSubmit {\n    color: #fff;\n    font-family: 'Poppins', sans-serif;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n    margin-top: 30px;\n    border: none;\n    border-radius: 4px;\n    background: rgba(81, 81, 249, 0.5);\n    display: flex;\n    width: 384px;\n    padding: 16px 24px;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n}\n\n.kbaContent {\n    padding: 80px 80px 0px 80px;\n}\n\n.kbaError {\n    border-radius: 4px;\n    border: 1px solid #ff4040;\n    background: #fff;\n    display: flex;\n    padding: 16px 12px;\n    align-items: center;\n    gap: 10px;\n    width: max-content;\n}\n\n.cardBodyCustom {\n    width: 100% !important;\n}\n\n.authSuccess {\n    margin-top: 20px;\n    border-radius: 4px;\n    border: 1px solid #5151f9;\n    background: #fff;\n    color: #5151f9;\n    font-family: 'Poppins', sans-serif;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    padding: 20px 0px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 30px;\n}\n\n/* Responsive Styling */\n@media (max-width: 768px) {\n    .kbaContent {\n        padding: 80px 40px 80px 40px;\n    }\n\n    .kbaSubmit {\n        width: 100%;\n    }\n}\n\n@media (max-width: 992px) {\n    .kbaContainer {\n        min-height: 100vh;\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"kbaTitle": `kbaAuthRetry_kbaTitle__EtRv7`,
	"kbaKnowledgeBasedText": `kbaAuthRetry_kbaKnowledgeBasedText__YwEuw`,
	"kbaQuestionBasedText": `kbaAuthRetry_kbaQuestionBasedText__snRx6`,
	"kbaRadioInputsContainer": `kbaAuthRetry_kbaRadioInputsContainer__FzdWE`,
	"kbaRadioInputs": `kbaAuthRetry_kbaRadioInputs__nWcf6`,
	"kbaSubmit": `kbaAuthRetry_kbaSubmit__wwS5W`,
	"kbaContent": `kbaAuthRetry_kbaContent__oO-K7`,
	"kbaError": `kbaAuthRetry_kbaError__uZRYD`,
	"cardBodyCustom": `kbaAuthRetry_cardBodyCustom__VfLln`,
	"authSuccess": `kbaAuthRetry_authSuccess__JR+F5`,
	"kbaContainer": `kbaAuthRetry_kbaContainer__-OJrQ`
};
export default ___CSS_LOADER_EXPORT___;
